import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";
import FlowLogo from "./FlowLogo";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Expertise", anchor: "#expertise", route: "/expertise" },
    { label: "Installation", anchor: "#installation", route: "/installation" },
    { label: "Services", anchor: "#services", route: "/maintenance" },
    { label: "Secteurs", anchor: "#secteurs", route: "/secteurs/studios" },
    { label: "Réalisations", anchor: "#realisations", route: "/realisations" },
    { label: "Équipe",       anchor: "#equipe",       route: "/equipe" },
    { label: "Contact",      anchor: "#contact",      route: "/contact" }
  ];

  const getHref = (link) => isHome ? link.anchor : link.route;
  const getLogo = () => isHome ? "#" : "/";

  return (
    <>
      <nav className={`nav-fixed ${scrolled ? "scrolled" : ""}`} data-testid="main-navigation">
        <div className="container-flow">
          <div className="nav-header-inner">
            {/* Logo - always visible */}
            {isHome ? (
              <a href="#" data-testid="logo-link" className="nav-logo-link"><FlowLogo className="flow-logo-large" /></a>
            ) : (
              <Link to="/" data-testid="logo-link" className="nav-logo-link"><FlowLogo className="flow-logo-large" /></Link>
            )}
            
            {/* Desktop navigation - center */}
            <div className="nav-desktop-links">
              {navLinks.map((link) => (
                isHome ? (
                  <a key={link.anchor} href={link.anchor} className="nav-link" data-testid={`nav-link-${link.anchor.slice(1)}`}>{link.label}</a>
                ) : (
                  <Link key={link.route} to={link.route} className="nav-link" data-testid={`nav-link-${link.label.toLowerCase()}`}>{link.label}</Link>
                )
              ))}
            </div>
            
            {/* Desktop CTA button */}
            <div className="nav-desktop-cta">
              {isHome ? (
                <a href="#contact" className="btn-primary inline-flex items-center gap-2 text-sm" data-testid="nav-cta-button">
                  Demander un devis <ChevronRight size={16} />
                </a>
              ) : (
                <Link to="/contact" className="btn-primary inline-flex items-center gap-2 text-sm" data-testid="nav-cta-button">
                  Demander un devis <ChevronRight size={16} />
                </Link>
              )}
            </div>
            
            {/* Mobile hamburger - far right */}
            <button className="nav-mobile-toggle" onClick={() => setMobileMenuOpen(true)} aria-label="Ouvrir le menu" data-testid="mobile-menu-button"><Menu size={24} /></button>
          </div>
        </div>
      </nav>
      <div className={`mobile-menu-overlay ${mobileMenuOpen ? "open" : ""}`} onClick={() => setMobileMenuOpen(false)} />
      <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`} data-testid="mobile-menu">
        <div className="flex justify-between items-center mb-8">
          <FlowLogo className="h-10" />
          <button onClick={() => setMobileMenuOpen(false)} aria-label="Fermer le menu" data-testid="mobile-menu-close" className="p-2 text-[#0E1A2B]"><X size={24} /></button>
        </div>
        <div className="flex flex-col gap-1">
          {navLinks.map((link) => (
            isHome ? (
              <a key={link.anchor} href={link.anchor} className="text-base font-medium py-3 text-[#0E1A2B] hover:text-[#00AFFF] transition-colors" onClick={() => setMobileMenuOpen(false)}>{link.label}</a>
            ) : (
              <Link key={link.route} to={link.route} className="text-base font-medium py-3 text-[#0E1A2B] hover:text-[#00AFFF] transition-colors" onClick={() => setMobileMenuOpen(false)}>{link.label}</Link>
            )
          ))}
          {isHome ? (
            <a href="#contact" className="btn-primary text-center mt-4 text-sm" onClick={() => setMobileMenuOpen(false)}>Demander un devis</a>
          ) : (
            <Link to="/contact" className="btn-primary text-center mt-4 text-sm" onClick={() => setMobileMenuOpen(false)}>Demander un devis</Link>
          )}
        </div>
      </div>
    </>
  );
};

export default Navigation;
